var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cf-node-properties__input" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.inputValue,
          expression: "inputValue"
        }
      ],
      staticClass: "form-control",
      class: { invalid: _vm.error },
      attrs: {
        type: "text",
        placeholder: _vm.placeholder,
        required: _vm.required
      },
      domProps: { value: _vm.inputValue },
      on: {
        blur: _vm.onBlur,
        input: function($event) {
          if ($event.target.composing) return
          _vm.inputValue = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _vm.errorMessage
      ? _c("div", { staticClass: "cf-node-properties__input-error" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }